<script>
import {useStore} from "vuex";
import {ref, watchEffect} from "vue";
import $ from "jquery";

export default {
  name: "BuyBox",

  setup(){

    let store = useStore()

    let orders = ref(store.state.order)


    watchEffect(() => {
      const $buyBox = $("#BuyBox");

      if (orders.value.products.length === 0) {
        $buyBox.removeClass('animate__fadeInUp').addClass('animate__fadeOutDown');
      }
    });





    return{

      orders,

    }
  }

}
</script>


<template>

  <br>
  <br>
  <br>
  <div id="BuyBox" class="animate__animated animate__fadeInUp p-body buy_box max_width w-100">
    <div class="bg-color rounded-pill d-flex align-items-center justify-content-between py-2 px-3">
      <div class="d-flex align-items-center">
        <img style="width: 2rem" src="../../assets/img/add-to-cart-withe.svg" alt="">
        <p v-if="orders.products[0]" class="font-4 mr-2 text-white">{{ orders.products[0].shop.shopname }}</p>
      </div>

      <div class="">
        <p class="d-flex text-white align-items-center font-4 mb-2">
          <span class="font-bold ml-1">{{ orders.orders_price.toLocaleString() }}</span>
          <span class="font-5">تومان</span>
        </p>
        <p class="d-flex text-white align-items-center font-4">
          <span class="font-bold ml-1">{{ orders.orders_count }}</span>
          <span class="font-5">قلم سفارش داده اید</span>
        </p>
      </div>
    </div>
  </div>

</template>


<style scoped>

.buy_box {
  position: fixed;
  bottom: 5px;
}

</style>